module.exports = __webpack_public_path__ + "static/media/ButtonNewIcon.f76420f9.svg";